/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PublicTherapist } from '../models/PublicTherapist';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class TherapistsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get Therapist by Slug
     * Get Therapist by Slug
     * @param slug
     * @returns PublicTherapist
     * @throws ApiError
     */
    public getPublicTherapist(
        slug: string,
    ): CancelablePromise<PublicTherapist> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/therapists/{slug}',
            path: {
                'slug': slug,
            },
        });
    }
    /**
     * Get Therapist by Id
     * Get Therapist by Id
     * @param id
     * @returns PublicTherapist
     * @throws ApiError
     */
    public getPublicTherapistById(
        id: number,
    ): CancelablePromise<PublicTherapist> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/therapists/id/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get Therapist by UUID
     * Get Therapist by UUID
     * @param uuid
     * @returns PublicTherapist
     * @throws ApiError
     */
    public getPublicTherapistByUud(
        uuid: string,
    ): CancelablePromise<PublicTherapist> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/therapists/uuid/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
}
